module.exports = {"id":"192350","name":"Javier Aquino","rating":"77","photo":"./data/images/photos/3/192350.png","club":{"name":"Tigres","logo":"./data/images/clubs/Tigres.png"},"positions":["MG","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JavierAquino0.json
// module id = 1942
// module chunks = 0